import { Component, input, inject, effect } from "@angular/core";
import { IfirmTaxNotesService } from "@shared/index";
import { NotesPanelComponent } from "@app/card-modal-component/panels/card-panels/notes-panel";
import { BaseNotesService } from "@classes/notes.class";
import { iFirmNotesPanelComponent } from "../../ifirm-notes-panel";

@Component({
    selector: "wk-ifirmtaxprep-notes-panel",
    imports: [NotesPanelComponent, iFirmNotesPanelComponent],
    templateUrl: "./ifirmtaxprep-notes-panel.component.html",
    styleUrl: "./ifirmtaxprep-notes-panel.component.scss",
    providers: [IfirmTaxNotesService, { provide: BaseNotesService, useExisting: IfirmTaxNotesService }],
})
export class IFirmtaxprepNotesPanelComponent {
    private readonly ifirmTaxNotesService = inject(IfirmTaxNotesService);

    public id = input.required<string | undefined>();

    constructor() {
        effect(() => {
            const id = this.id();
            if (!id) return;
            this.ifirmTaxNotesService.id.set(id);
        });
    }
}
